import React from 'react';

import ModalPopup from '../../elements/ModalPopup';

type Props = Readonly<{
    index: string;
    casino: string;
}>;
export default function QRCodeModal({ index, casino }: Props): React.JSX.Element {
    function addQRCode(image: string, title: string) {
        return (
            <div className="col p-4">
                <p>
                    <strong>{title}</strong>
                </p>
                <img src={`data:image/png;base64,${image}`} style={{ width: '200px' }} alt={`QR Code for ${title}`} />
            </div>
        );
    }

    function getModalContent(): React.JSX.Element {
        return (
            <div className="row text-center">
                {addQRCode(index, 'Homepage')}
                {casino && addQRCode(casino, 'Casino homepage')}
            </div>
        );
    }

    return (
        <ModalPopup
            buttonContent={<i className="fas fa-qrcode" />}
            buttonClass="btn-primary"
            modalTitle="QR Code"
            modalContent={getModalContent()}
        />
    );
}
